import { createAsyncThunk, isFulfilled, SerializedError } from '@reduxjs/toolkit';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { NAMESPACE } from '../../constants';
import { cancelSubscription } from './actions';
import { Subscription } from '../../records/Subscription';

export const cancelSubscriptions = createAsyncThunk(`${NAMESPACE}/subscriptions/cancel`, async (ids: string[], { dispatch }) => {
  try {
    const subscriptions = await Promise.all(ids.map(async (id) => {
      const action = await dispatch(cancelSubscription(id));
      if (isFulfilled(action)) return Subscription.parseSubscription(action.payload.data);
      throw action.error;
    }));
    const message = subscriptions.length > 1 ?
      'You’ve successfully canceled your plans.' :
      `You’ve successfully canceled your ${subscriptions[0].displayName()} plan.`;
    // eslint-disable-next-line
    return dispatch(notificationActions.notifySuccess(message, undefined, false, undefined, true));

  } catch (err) {
    const error = (err as SerializedError);
    dispatch(notificationActions.notifyDanger(
      error.message, 'We\'ve experienced an issue while loading data.', true, undefined, true,
    ));
  }
});
